export default __webpack_public_path__ + "static/media/A_wdt_c_cap_3.e29bfa5a.mp3";